(function () {
  'use strict';

  const cfg = window.positieOverlayConfig || {};
  const optisLabelName = cfg.optisLabelName || 'Positie';
  const headingText = cfg.headingText || '5. Op welke positie wilt u bedrukking?';

  let observer = null;

  function findOptisStackByLabel(labelText) {
    const stacks = document.querySelectorAll('.po-stack');
    for (let i = 0; i < stacks.length; i++) {
      const labelEl = stacks[i].querySelector('.po-label-container .po-label > span, .po-label-container .po-label');
      if (!labelEl) continue;
      const txt = (labelEl.textContent || '').replace('*', '').trim();
      if (txt === labelText) return stacks[i];
    }
    return null;
  }

  function escape(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function refreshSelection(stack) {
    const select = stack.querySelector('select');
    if (!select) return;
    const wrapper = stack.querySelector('[data-positie-overlay]');
    if (!wrapper) return;
    const currentValue = select.value;
    wrapper.querySelectorAll('[data-positie-radio]').forEach(function (radio) {
      radio.checked = (radio.value === currentValue);
    });
  }

  function applyOverlay() {
    const stack = findOptisStackByLabel(optisLabelName);
    if (!stack) return false;

    // Preserve original OPTIS label so cart property keeps the canonical name
    if (!stack.dataset.optisOriginalLabel) {
      stack.dataset.optisOriginalLabel = optisLabelName;
    }

    if (stack.dataset.positieOverlayApplied === '1') {
      refreshSelection(stack);
      keepDropdownHidden(stack);
      return true;
    }

    const select = stack.querySelector('select');
    const dropdownContainer = stack.querySelector('.po-option--container');
    if (!select || !dropdownContainer) return false;

    // Replace the heading text (preserve required asterisk if present)
    const headingLabel = stack.querySelector('.po-label-container .po-label');
    if (headingLabel) {
      headingLabel.innerHTML = '<span class="positie-overlay__heading">' + escape(headingText) + '</span>';
    }

    // Read option data from the OPTIS-rendered dropdown options
    const optionData = [];
    stack.querySelectorAll('.po-dropdown-thumbnail-option[data-value]').forEach(function (opt) {
      const value = opt.getAttribute('data-value');
      if (!value || value === '-- Please select --') return;
      const img = opt.querySelector('img');
      const textEl = opt.querySelector('.po_option_value');
      optionData.push({
        value: value,
        text: textEl ? textEl.textContent.trim() : value,
        imgSrc: img ? img.getAttribute('src') : null
      });
    });

    if (optionData.length === 0) return false;

    // Build cards wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'positie-overlay';
    wrapper.setAttribute('data-positie-overlay', '');

    const cards = document.createElement('div');
    cards.className = 'positie-overlay__cards';

    const radioName = 'positie-overlay-' + stack.id;

    optionData.forEach(function (data) {
      const card = document.createElement('label');
      card.className = 'positie-overlay__card';
      card.setAttribute('data-positie-value', data.value);
      let html =
        '<input type="radio" name="' + escape(radioName) + '" value="' + escape(data.value) + '" data-positie-radio>' +
        '<span class="positie-overlay__check" aria-hidden="true"></span>' +
        '<span class="positie-overlay__text">' + escape(data.text) + '</span>';
      if (data.imgSrc) {
        html += '<img class="positie-overlay__image" src="' + escape(data.imgSrc) + '" alt="">';
      }
      card.innerHTML = html;
      cards.appendChild(card);
    });

    wrapper.appendChild(cards);
    dropdownContainer.parentNode.insertBefore(wrapper, dropdownContainer);

    // Wire up click → sync to underlying <select>
    wrapper.querySelectorAll('[data-positie-radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        // Update the hidden <select> and fire change so BSS_PO.handleChangeValue picks it up
        select.value = radio.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Hide the original visible dropdown (the <select> stays for OPTIS, just visually gone)
    keepDropdownHidden(stack);

    stack.dataset.positieOverlayApplied = '1';
    refreshSelection(stack);

    // Re-apply on OPTIS mutations
    if (!observer) {
      observer = new MutationObserver(function () {
        keepDropdownHidden(stack);
        refreshSelection(stack);
      });
      observer.observe(stack, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    }
    return true;
  }

  function keepDropdownHidden(stack) {
    const visibleDropdown = stack.querySelector('.po-select-dropdown-thumbnail');
    if (visibleDropdown && visibleDropdown.style.display !== 'none') {
      visibleDropdown.style.setProperty('display', 'none', 'important');
    }
  }

  function init() {
    // Re-sync on any OPTIS-related select change (covers BSS_PO updates from elsewhere)
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.po-stack select')) {
        document.querySelectorAll('.po-stack[data-positie-overlay-applied="1"]').forEach(refreshSelection);
      }
    });

    if (applyOverlay()) return;
    let tries = 0;
    const interval = setInterval(function () {
      tries++;
      if (applyOverlay() || tries > 60) clearInterval(interval);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
